import script from "./payManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./payManagement.vue?vue&type=script&setup=true&lang=js"

import "./payManagement.vue?vue&type=style&index=0&id=3153d5ae&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3153d5ae"]])

export default __exports__